export default __webpack_public_path__ + "static/media/sd-event1.81262d5c.png";